/**
 * A component that renders a single day cell in the Calendar.
 */
import React from "react";
import moment from "moment";
import styled from "styled-components";
import { connect } from "react-redux";
import classNames from "classnames";

import { getTheme } from "../../actions";
import type { GlobalState } from "../../lib/types";

const CalendarDay = (props) => {
  const { day, firstLineFormat, secondLineFormat, selected, unavailable, onSelected } = props;

  const name = day.format(firstLineFormat || "ddd");
  const date = day.format(secondLineFormat || "D");
  const isToday = moment().isSame(day, "day");

  const onClickCallback = unavailable ? undefined : () => onSelected(day);

  const dayClass = classNames("day-option", {
    unavailable,
    selected,
    today: isToday,
  });

  return (
    <DayOuter className={dayClass} disabled={unavailable} onClick={onClickCallback}>
      <DayInner className={dayClass}>
        <strong>{date}</strong>
        <div>{name}</div>
      </DayInner>
    </DayOuter>
  );
};

const DayInner = styled.div`
  font-style: normal;
  text-align: center;
  letter-spacing: 0.28px;
  color: #595d61;
  padding: 10px 15px;
  border-radius: 8px;
  position: relative;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;

  div {
    font-size: 12px;
  }

  strong {
    font-size: 16px;
  }

  &.selected {
    box-shadow: 0px 9px 26px #c5c5c5;
    background: ${(props) => props.theme.brandColor};
    color: #fff;
  }

  &.unavailable {
    opacity: 0.6;
    border-color: #a8a8a8;
    color: #a8a8a8;
  }

  &.today:not(.selected) {
    color: ${(props) => props.theme.brandColor};
  }

  &:hover:not(.selected) {
    background-color: rgba(${(props) => props.theme.brandColorRGB}, 0.09);
  }
`;

const DayOuter = styled.div`
  border: none;
  margin: 10px 0px;
  background: transparent;
  cursor: pointer;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  position: relative;

  &:first-of-type:not(:hover):not(.selected):after,
  &:last-of-type:not(:hover):not(.selected):after {
    content: "";
    display: block;
    position: absolute;
    left: 0;
    top: 0;
    height: 100%;
    width: 100%;
  }

  &:first-of-type:not(:hover):not(.selected):after {
    background: linear-gradient(to right, white, rgba(255, 255, 255, 0.01));
  }

  &:last-of-type:not(:hover):not(.selected):after {
    background: linear-gradient(to right, rgba(255, 255, 255, 0.01), white);
  }
`;

function mapStateToProps(state: GlobalState) {
  return {
    theme: getTheme(state),
  };
}

export default connect(mapStateToProps)(CalendarDay);
